import React from 'react';
import Config from '../Config';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default class Support extends React.Component {
  componentWillMount() {
    document.body.classList.add('support-page');
  }

  componentWillUnmount(){
    document.body.classList.remove('support-page');
  }
  
  render() {
    return (
      <Container className="text-page">
        <Row className="justify-content-md-center"> 
          <Col sm="8">
            <div class="text-box">
              <h1>Support</h1>
              <p>If you have any questions about the app please go to contact page by <a href={Config.contactURI} target="_blank">clicking here.</a></p>
            </div>
          </Col>
        </Row>
      </Container> 
    )
  }
}
